// covered-by: frontends/carrie/src/ask-v2/home/__tests__/ActionStack.test.tsx
import { type AskPunttActionCard } from "@mg/schemas/src/christo/askPunttBriefing";
import { Button, Heading } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { DigDeeperBody } from "./DigDeeperPanel";

type DigDeeperSidebarProps = {
  card: AskPunttActionCard;
  onClose: () => void;
};

export function DigDeeperSidebar({ card, onClose }: DigDeeperSidebarProps) {
  const { t } = useTranslation("ui");

  return (
    <aside
      data-testid="ask-v2-dig-deeper-sidebar"
      aria-label={t("askV2.home.digDeeperTitle")}
      className="flex size-full max-w-md flex-col gap-3 border-l border-puntt-neutral-gray-6 bg-base-white px-5 py-6"
    >
      <div className="flex items-center justify-between gap-2">
        <Heading as="h3" size="4">
          {t("askV2.home.digDeeperTitle")}
        </Heading>
        <Button
          size="1"
          variant="ghost"
          data-testid="ask-v2-close-sidebar"
          onClick={onClose}
        >
          {t("askV2.home.closeSidebar")}
        </Button>
      </div>
      <DigDeeperBody card={card} />
    </aside>
  );
}
